<template>
  <v-content v-if="loading">
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <!-- 确认框 -->
    <confirm ref="myConfirm"
             @clickFun="clickFun"></confirm>
    <!-- 提示框 -->
    <confirm ref="myAlert"></confirm>

    <v-row class="rows btn-group">
      <v-btn @click="openAddDialog">添加</v-btn>
      <v-btn @click="doDelete()">删除</v-btn>
    </v-row>

    <v-flex class="table-style">
      <v-data-table v-model="selected"
                    :headers="headers"
                    :items="tableDate"
                    :single-select="singleSelect"
                    item-key="userId"
                    show-select
                    class="elevation-1">
        <template v-slot:top>
          <v-switch v-model="singleSelect"
                    label="禁止多选"
                    class="pa-3"></v-switch>
        </template>
        <template v-slot:item.userSex="{ item }">
          <v-flex>
            {{getSex(item.userSex)}}
          </v-flex>
        </template>
        <template v-slot:item.userStatus="{ item }">
          <v-flex>
            {{getStatus(item.userStatus)}}
          </v-flex>
        </template>
        <template v-slot:item.option="{ item }">
          <v-icon small
                  class="mr-2"
                  @click="openUpdateDialog(item,2)"
                  title="修改信息">fa fa-magic</v-icon>
          <v-icon small
                  class="mr-2"
                  @click="openUpdateDialog(item,3)"
                  title="修改密码">fa fa-paint-brush</v-icon>
        </template>
      </v-data-table>
    </v-flex>

    <!-- 添加用户弹窗 -->
    <v-dialog v-model="userDialog"
              width="500">
      <v-card>
        <v-card-text>
          <v-card-title primary-title>{{btnType==1?"添加新用户":(btnType==2?"修改用户信息":"修改用户密码")}}</v-card-title>

          <v-form :model="formUser"
                  ref="formUser"
                  @keyup.enter.native="handleLogin">
            <v-row v-if="btnType !=3">
              <v-card-title class="add-title"
                            primary-title>用户名:</v-card-title>
              <v-text-field class="add-field"
                            name="login"
                            type="text"
                            v-model="formUser.userName"
                            :error="error"
                            :rules="[rules.required]" />
            </v-row>
            <v-row v-if="btnType !=2">
              <v-card-title class="add-title"
                            primary-title>密码:</v-card-title>
              <v-text-field class="add-field"
                            :type="hidePassword ? 'text':'password'"
                            :append-icon="hidePassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
                            :rules="[rules.required]"
                            v-model="formUser.userPassword"
                            :error="error"
                            @click:append="hidePassword = !hidePassword" />
            </v-row>
            <v-row v-if="btnType !=3">
              <v-card-title class="add-title"
                            primary-title>性别:</v-card-title>
              <v-radio-group class="add-field"
                             v-model="formUser.userSex"
                             :row="true">
                <v-radio label="男"
                         value="0"></v-radio>
                <v-radio label="女"
                         value="1"></v-radio>
              </v-radio-group>
            </v-row>
            <v-row v-if="btnType !=3">
              <v-card-title class="add-title"
                            primary-title>电话:</v-card-title>
              <v-text-field class="add-field"
                            name="login"
                            type="text"
                            v-model="formUser.userPhone" />
            </v-row>
            <v-row v-if="btnType !=3">
              <v-card-title class="add-title"
                            primary-title>状态:</v-card-title>
              <v-radio-group class="add-field"
                             v-model="formUser.userStatus"
                             :row="true">
                <v-radio label="禁用"
                         value="0"></v-radio>
                <v-radio label="正常"
                         value="1"></v-radio>
              </v-radio-group>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"
                 @click="userDialog = false">取消</v-btn>
          <v-btn color="primary"
                 @click="doClick">{{btnType==1?"添加":"修改"}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>


<script>
import Loading from '@/components/core/Loading'
//新添用户对象
const NewUser = {
  //用户名
  userName: "",
  //密码
  userPassword: "123456",
  //性别
  userSex: "0",
  //电话
  userPhone: "",
  //状态
  userStatus: "1"
}
export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      singleSelect: false,
      //添加弹框标识
      userDialog: false,
      //1:添加 2:修改
      btnType: 1,
      formUser: {},
      test: [],
      //密码是否可见
      hidePassword: false,
      //是否错误
      error: false,
      //错误提醒
      rules: {
        required: (value) => !!value || '必填项，不能为空'
      },
      sex: ["男", "女"],
      status: ["禁用", "正常"],
      //复选框选中的用户Id
      selected: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'userId',
        },
        { text: '姓名', value: 'userName' },
        { text: ' 联系电话', value: 'userPhone' },
        { text: '性别', value: 'userSex' },
        { text: '状态', value: 'userStatus' },
        { text: '创建时间', value: 'createTime' },
        { text: '操作', value: 'option', sortable: false },
      ],
      tableDate: [],
    }
  },
  created () {
    this.init();
  },
  mounted () {
    this.$emit("updateNavigationValue", 6)
  },
  methods: {
    init () {
      this.isLoading = true;
      this.$store
        .dispatch("getAllUserList")
        .then(response => {
          this.tableDate = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.loading = true;
    },

    //获取性别
    getSex (val) {
      return this.sex[val]
    },
    //获取状态
    getStatus (val) {
      return this.status[val]
    },

    //打开新添界面
    openAddDialog () {
      this.formUser = NewUser;
      this.btnType = 1;
      this.userDialog = true;
    },

    doClick () {
      this.btnType == 1 ? this.addUser() : this.updateUser()
    },

    //新添用户
    addUser () {
      if (this.formUser.userName && this.formUser.userPassword) {
        this.isLoading = true;
        this.$store.dispatch("AddUser", this.formUser).then(response => {
          let result = response.data.data;
          let str = "";
          str = result == 200 ? "添加成功!" : "添加失败!";
          this.$refs.myAlert.show(str, {
            type: 'alert'
          })
          this.userDialog = false;
          this.init();
        })
          .catch(() => {
            this.isLoading = false;
          });
      }

    },

    //删除
    doDelete () {
      if (this.selected.length > 0) {
        this.$refs.myConfirm.show("确认删除所选用户吗?", {})
      } else {
        this.$refs.myAlert.show("请选择用户", {
          type: 'alert'
        })
      }

    },


    //确认删除
    clickFun (type) {
      if (type == "clickConfirm") {
        this.isLoading = true;
        for (var i = 0; i < this.selected.length; i++) {
          this.test[i] = this.selected[i].userId
        }
        this.$store.dispatch("Deleteuserinfo", this.test).then(response => {
          let result = response.data.data;
          let str = "";
          str = result == 200 ? "删除成功!" : "删除失败!";
          this.$refs.myAlert.show(str, {
            type: 'alert'
          })
          this.init();
        })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },

    //打开修改界面
    openUpdateDialog (obj, value) {
      if (value == 2) {
        this.formUser = obj;
        this.formUser.userPassword = null;
      } else {
        this.formUser = {};
        this.formUser.userId = obj.userId;
      }
      this.btnType = value;
      this.userDialog = true;
    },
    //修改用户  
    updateUser () {
      if ((this.btnType == 2 && this.formUser.userName) || (this.btnType == 3 && this.formUser.userPassword)) {
        this.$store.dispatch("UpdateUser", this.formUser).then(response => {
          let result = response.data.data;
          let str = "";
          str = result == 200 ? "修改成功!" : "修改失败!";
          this.$refs.myAlert.show(str, {
            type: 'alert'
          })
          this.userDialog = false;
          this.init();
        })
          .catch(() => {
            this.isLoading = false;
          });
      }

    },

  }
}
</script>

<style scoped>
.rows {
  margin: 0;
  justify-items: center;
  align-items: center;
}
.btn-group {
  flex: none !important;
  width: 300px;
}
.btn-group >>> .v-btn {
  margin: 5px;
  background: cadetblue !important;
}
.table-style {
  width: 98%;
  height: 680px;
  overflow: auto;
}

.add-title {
  width: 100px;
  flex: none;
}
.add-field {
  width: 300px;
  flex: none;
}
</style>